import { Injectable } from '@angular/core';

@Injectable()
export class ResourceStoreService {
  readonly applicationTitle = 'Webowa Aplikacja Klienta Brokera ZSIN';
  readonly loginPageTitle = 'Logowanie do systemu';

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/services/resource-store/resource-store.service.ts